export default {
      id: "key-usage",
      viewBox: "0 0 13 14",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#key",
      toString: function () {
        return this.url;
      }
    }